import { cookiesStorage } from './cookies.util';

/**
 * Storage key shared by all device-token persistence paths (localStorage,
 * cookie, and the axios request interceptor that forwards the token as
 * the `X-Device-Token` header).
 */
export const DEVICE_TOKEN_KEY = 'X-Device-Token';

export const getDeviceToken = (): string | null => {
	try {
		return localStorage.getItem(DEVICE_TOKEN_KEY);
	} catch {
		return null;
	}
};

export const saveDeviceToken = (token: string): void => {
	try {
		localStorage.setItem(DEVICE_TOKEN_KEY, token);
	} catch {
		console.error('[DeviceToken] Failed to save device token');
	}
};

export const removeDeviceToken = (): void => {
	try {
		localStorage.removeItem(DEVICE_TOKEN_KEY);
	} catch {
		console.error('[DeviceToken] Failed to remove device token');
	}
};

/**
 * Double-storage per spec (TAB-01 / TAB-02): localStorage + cookie. The
 * backend additionally sets an HttpOnly cookie via Set-Cookie response
 * header — that path is independent and server-controlled.
 */
export const persistDeviceToken = (token: string): void => {
	saveDeviceToken(token);
	cookiesStorage.setItem(DEVICE_TOKEN_KEY, token);
};

export const clearDeviceToken = (): void => {
	removeDeviceToken();
	cookiesStorage.removeItem(DEVICE_TOKEN_KEY);
};
